"use client"

import { LockKeyhole } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LockKeyholeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LockKeyholeIcon = component(Icon)({ as: LockKeyhole })
